import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RegisterData from '../../components/pages/register/Data';
import RegisterImages from '../../components/pages/register/Images';
import RegisterVideo from '../../components/pages/register/Video';
import Modal from '../../components/master/Modal';
import { getDirection, pexios } from '../../utils/functions';
import CleanCar from '../../assets/images/register-principles/cleanCar.png';
import Lamp from '../../assets/images/register-principles/light.png';
import Camera360 from '../../assets/images/register-principles/carCamera.png';
import SportCar from '../../assets/images/register-principles/parking.png';
import Kilometer from '../../assets/images/register-principles/kilometer.png';
import LicenseCard from '../../assets/images/register-principles/licenseCard.png';
import Limitation from '../../assets/images/register-principles/20_limitation.png';
import { useDispatch } from 'react-redux';
import { setAccidentInfo, setRouterData, setUserAction } from '../../redux/actions';
import { useDidMount } from '../../utils/hooks';
import Loading from '../../assets/images/gifs/loading.gif'

export default function Register({ history }) {

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch()

    const [step, setStep] = useState(0);
    const [registerId, setRegisterId] = useState(null);
    const [carTypeId, setCarTypeId] = useState(null);
    // const [openModal ,setOpenModal] = useState(false);
    const[loader,setLoader] = useState(false)
    useDidMount(()=> {
        dispatch(setUserAction(''));
        setLoader(true)
        pexios('/api/check_old_register')
        .then((res)=>{
            if(res.data.type) {
                dispatch(setRouterData({ id:res.data.id, type: 'register' }));
                history.push('/register-single');
            }
            setLoader(false)
        })

    })
    function changeStep(step, data) {
        setStep(step);
        if (data) {
            setRegisterId(data.registerId);
            setCarTypeId(data.carTypeId)
        }
    }
    function startRegister() {
        dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'body'}))
        dispatch(setRouterData({type: 'register'}));
        history.push('/plans')
    }
    return (
        <div className='register content'>
            {/* <Modal visible={openModal}>
                <div className="modal-content register-modal">
                    <div className={`modal-body mb20 ${getDirection(i18n.language) ==='rightToLeft'?' text-right': ' text-left'}`}>
                        <p className='modal-title mb10'>{t('Register modal title')}</p>

                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 1-clause')}</p>
                            <img src={CleanCar} alt="clean car"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 2-clause')} </p>
                            <img src={Lamp} alt="lamp"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 3-clause')}</p>
                            <img src={SportCar} alt="sport car"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 4-clause')}</p>
                            <img src={Camera360} alt="camera"/>
                        </div>
                    </div>
                <button className='btn btn-circle btn-white-purple btn-block' onClick={()=>setOpenModal(false)}>{t('Get it')}</button>
                </div>
            </Modal> */}
            {<Modal visible={loader}>
            <div className='loader-modal'>
                <img src={Loading} alt="loader"/>
            </div>
            </Modal>}
            {
                step === 0 &&
                <div className='register-principles'>
                    <p className='guide-text mb30 mx10'> لطفا جهت درخواست بازدید اولیه صدور بیمه نامه موارد زیر را رعایت فرمایید</p>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p className='mx10'>{t('Register modal 1-clause')}</p>
                        <img src={CleanCar} alt="clean car"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>{t('Register modal 2-clause')} </p>
                        <img src={Lamp} alt="lamp"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>{t('Register modal 3-clause')}</p>
                        <img src={SportCar} alt="sport car"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>{t('Register modal 4-clause')}</p>
                        <img src={Camera360} alt="camera"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>روشن بودن خودرو در زمان تصویربرداری از صفحه کیلومتر</p>
                        <img src={Kilometer} alt="camera"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>همراه داشتن کارت خودرو</p>
                        <img src={LicenseCard} alt="camera"/>
                    </div>
                    <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                        <p>حداکثر زمان تصویربرداری 20 دقیقه می باشد</p>
                        <img src={Limitation} alt="camera"/>
                    </div>
                    <div className='mx30'>
                    <button className='btn btn-circle btn-white-purple btn-block mt30' onClick={startRegister}>شروع فرآیند ثبت درخواست</button>
                    </div>
                </div>
            }
            {
                step === 1 && <RegisterData changeStep={changeStep} />
            }
            {/* {
                step === 2 &&
                <RegisterImages
                    changeStep={changeStep}
                    car_type_id={carTypeId}
                    register_id={registerId}
                    history={history}
                />
            }
            {
                step === 3 &&
                <RegisterVideo
                    registerId={registerId}
                />
            } */}
        </div>
    );

}
